import { TooltipWrapper } from 'components/TooltipWrapper/TooltipWrapper';
import { Button, IconArrowLeft, IconArrowRight, IconAlert } from 'uikit';

import type { IHeaderParams } from 'ag-grid-community';
import type React from 'react';
import { useCallback, useMemo } from 'react';

interface IActsTotalHeaderComponent extends IHeaderParams {
    collapseKeys: string[];
    isExpanded: boolean;
    setIsExpanded: (isExpanded: boolean) => void;
    hasExcessCompletedOthers?: boolean;
}

export const ActsTotalHeaderComponent: React.FC<IActsTotalHeaderComponent> = (props) => {
    const { collapseKeys, displayName, api, isExpanded, setIsExpanded, hasExcessCompletedOthers } = props;

    const onExpandCollapseClick = useCallback(() => {
        api.setColumnsVisible(collapseKeys, !isExpanded);
        setIsExpanded(!isExpanded);
    }, [api, collapseKeys, isExpanded, setIsExpanded]);

    const toolTipMessage = useMemo(
        () => (isExpanded ? 'Скрыть детализацию по Актам' : 'Отобразить детализацию по Актам'),
        [isExpanded],
    );

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {hasExcessCompletedOthers && (
                <TooltipWrapper message="Превышает план" isInteractive={false}>
                    <IconAlert size="xs" view="alert" style={{ marginRight: 5 }} />
                </TooltipWrapper>
            )}
            {displayName}
            {!!collapseKeys.length && (
                <TooltipWrapper message={toolTipMessage} key={`${isExpanded}`}>
                    <Button
                        view="clear"
                        iconRight={isExpanded ? IconArrowLeft : IconArrowRight}
                        onlyIcon
                        onClick={onExpandCollapseClick}
                        size="xs"
                        form="brick"
                    />
                </TooltipWrapper>
            )}
        </div>
    );
};

ActsTotalHeaderComponent.displayName = 'ActsTotalHeaderComponent';
